/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_macro_calories = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily calories`)
};

const es_macro_calories = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calorías diarias`)
};

const de_macro_calories = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tägliche Kalorien`)
};

const nl_macro_calories = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dagelijkse calorieën`)
};

const fr_macro_calories = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calories quotidiennes`)
};

const it_macro_calories = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calorie giornaliere`)
};

const pt_br2_macro_calories = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calorias diárias`)
};

const pt_macro_calories = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calorias diárias`)
};

const ja_macro_calories = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1日のカロリー`)
};

const zh_macro_calories = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每日热量`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const macro_calories = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.macro_calories(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("macro_calories", locale)
	if (locale === "en") return en_macro_calories(inputs)
	if (locale === "es") return es_macro_calories(inputs)
	if (locale === "de") return de_macro_calories(inputs)
	if (locale === "nl") return nl_macro_calories(inputs)
	if (locale === "fr") return fr_macro_calories(inputs)
	if (locale === "it") return it_macro_calories(inputs)
	if (locale === "pt-BR") return pt_br2_macro_calories(inputs)
	if (locale === "pt") return pt_macro_calories(inputs)
	if (locale === "ja") return ja_macro_calories(inputs)
	return zh_macro_calories(inputs)
};